import ObjectListWidget from '@plone/volto/components/manage/Widgets/ObjectListWidget';
import { validaInterno, validaEsterno } from '../../config/validators';
import warningSVG from '../../theme/images/warning.svg';
import { defineMessages, useIntl } from 'react-intl';

const ItemSchema = {
    title: 'Telefono',
    properties: {
        indicazioni: {
            description: "",
            factory: "Text line (String)",
            title: "Etichetta",
            type: "string",
            default: "Ufficio",
        },
        interno: {
            description: "Solo 4 cifre",
            factory: "Text line (String)",
            title: "Interno",
            type: "string",
            validators: [validaInterno],
        },
        principale: {
            description: "Apparirà nella ricerca (selezionare obbligatoriamente almeno un numero di telefono come 'Principale')",
            factory: "Yes/No",
            title: "Principale",
            type: "boolean"
        },
        telefono: {
            description: "Es: 0805711234",
            factory: "Text line (String)",
            title: "Telefono",
            type: "string",
            validators: [validaEsterno],
        }
    },
    fieldsets: [
        {
            id: 'default',
            title: 'Telefono',
            fields: [
                'telefono',
                'interno',
                'indicazioni',
                'principale',
            ],
        },
    ],
    required: ['indicazioni'],
};

const messages = defineMessages({
    invalidField: {
        id: 'invalidField',
        defaultMessage: 'Valore non valido!',
    }
});

const validFields = {};

const checkValidations = () => {
    const saveButton = document.getElementById('toolbar-save');
    if (!saveButton) return;

    const isValid = Object.values(validFields).every(v => v === true);
    saveButton.disabled = !isValid;
};

const handleBlur = (e, intl) => {
    const field = e.target;
    var res;
    if (field.id.startsWith('field-interno')) {
        res = validaInterno(field.value);
    }

    if (field.id.startsWith('field-telefono')) {
        res = validaEsterno(field.value);
    }

    validFields[field.id] = res;

    const errorSpan = field.parentElement.querySelector('.badge.badge-danger');
    if (!res) {
        if (!errorSpan) {
            const error = document.createElement('span');
            error.className = 'badge badge-danger h-25 ms-3 align-self-center';
            error.textContent = intl.formatMessage(messages.invalidField);
            field.parentElement.appendChild(error);
        }
    } else {
        if (errorSpan) {
            errorSpan.remove();
        }
    }

    checkValidations();
};


function addValidationListeners(count, intl) {
    setTimeout(() => {
        const interno_field = document.querySelector('[id^="field-interno-1-telefono-' + count + '"]');
        const esterno_field = document.querySelector('[id^="field-telefono-0-telefono-' + count + '"]');
        if (interno_field) {
            interno_field.addEventListener('blur', (e) => handleBlur(e, intl));
        }
        if (esterno_field) {
            esterno_field.addEventListener('blur', (e) => handleBlur(e, intl));
        }
    }, 500);
}



const TelefoniWidget = (props) => {
    const intl = useIntl();
    return (
        <>
            {Array.isArray(props.value?.items) && props.value.items.length === 0 && (
                <div className="strutturaAfferenza-responsabile m-2 p-2 active">
                    <img src={warningSVG} alt="Warning Icon" />
                    Riferimenti telefonici da definire. In mancanza, verrà riportato il telefono del suo responsabile.
                </div>
            )}
            <ObjectListWidget
                schema={ItemSchema}
                {...props}
                value={props.value?.items || props.default?.items || []}
                onChange={(id, value) => {
                    addValidationListeners(value.length - 1, intl);
                    props.onChange(id, { items: value })
                }}
            />
        </>

    );
};

export default TelefoniWidget;